class ProceedPayment {
  constructor({ clientSecret, isCancellationAllowed }) {
    this.clientSecret = clientSecret;
    this.isCancellationAllowed = isCancellationAllowed;
  }
}

export default ProceedPayment;
